import "../css/Error.css";

const Error = ({visible, noBackground, text}) => {
    return <div className = "error-container" style={{backgroundColor: noBackground && "transparent", boxShadow: noBackground && "0 0 0 0"}} data-status={visible ? "show" : "hidden"}>
        <i className="fa-solid fa-circle-exclamation fa-4x"></i>
        <span>{text}</span>
    </div>
}

export default Error